// extracted by mini-css-extract-plugin
export var infoRow = "_ua-2";
export var labelContainer = "_ua-0";
export var rightInfo = "_ua-1";